import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { io } from 'socket.io-client';
import QRCode from 'react-qr-code';
import CloudIcon from '../../../assets/images/cloud-icon.svg';
import { useAuth } from '../../../hooks/useAuth';

const QrModal = ({ onClick }) => {
  const { t } = t => t; // Заглушка, если t не пришел, но используем твой хук ниже
  const { t: translate } = useTranslation();

  const [socket, setSocket] = useState(null);
  const { isAuthenticated, setIsAuthenticated, setAuthCookie } = useAuth();
  const [qrValue, setQrValue] = useState('');

  useEffect(() => {
    if (!isAuthenticated) {
      const wsHost = "https://api.fizika.app/";
      const newSocket = io(wsHost, { reconnectionAttempts: 5 });

      newSocket.on('number', (data) => {
        if (data && !data.statusSuccess) {
          setQrValue(`pt-pro://${data.client_Id}-${data.qr_code}`);
        }
        if (data.statusSuccess) {
          setAuthCookie(data.qr_code);
          setIsAuthenticated(true);
          newSocket.off('number');
        }
      });

      setSocket(newSocket);
      return () => {
        newSocket.off('number');
        newSocket.disconnect();
      };
    }
  }, []);

  const handleClose = () => {
    if (socket) socket.disconnect();
    onClick();
  };

  return (
      <div className="qr-overlay" onClick={handleClose}>
        <div className="qr-new-modal" onClick={e => e.stopPropagation()}>
          <button className="qr-new-modal__close" onClick={handleClose}>×</button>

          {/* ШАПКА: Фиксированный размер, только графика */}
          <div className={`qr-new-modal__header ${isAuthenticated ? 'qr-new-modal__header--success' : ''}`}>
            {isAuthenticated ? (
                <div className="qr-new-modal__image-container">
                  <img src={CloudIcon} className="qr-new-modal__success-icon" alt="Success" />
                </div>
            ) : (
                <div className="qr-new-modal__qr-card">
                  {qrValue ? (
                      <div className="qr-new-modal__white-bg">
                        <QRCode
                            value={qrValue}
                            size={140}
                            fgColor="#20252B"
                            bgColor="#FFFFFF"
                            level="M"
                        />
                      </div>
                  ) : (
                      <div className="qr-new-modal__loader-placeholder">
                        <div className="loader-mini"></div>
                      </div>
                  )}
                </div>
            )}
          </div>

          <div className="qr-steps-list">
            {/* СТАТИЧНЫЙ ЗАГОЛОВОК: Свой класс вместо settings */}
            <h2 className="qr-new-modal__title">{translate('translate.qr_modal1_title')}</h2>

            <div className="qr-step qr-step--1">
              <div className="qr-step__icon"></div>
              <div className="qr-step__text">
                <p className="qr-step__title">{translate('translate.qr_modal_item1_1')}</p>
                <p className="qr-step__desc">{translate('translate.qr_modal_item1_2')}</p>
              </div>
            </div>

            <div className="qr-step qr-step--2">
              <div className="qr-step__icon"></div>
              <div className="qr-step__text">
                <p className="qr-step__title">{translate('translate.qr_modal_item2_1')}</p>
                <p className="qr-step__desc">{translate('translate.qr_modal_item2_2')}</p>
              </div>
            </div>

            <div className="qr-new-modal__footer">
              <p>{translate('translate.qr_modal_message')}</p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default QrModal;